import { isEmpty } from 'lodash';
import { enrich } from '../../helpers';

const selectTeamFilters = stateSlice =>
  isEmpty(stateSlice && stateSlice.filters) ? enrich({}) : stateSlice.filters;

// eslint-disable-next-line import/prefer-default-export
export { selectTeamFilters };
